import { IPassportMassCancelReason } from '../interfaces/IPassportMassCancelReason';
import { apiGet } from '../../MainModule/common/apiTools';
import { APIServiceEnum } from '../../MainModule/enums/APIServiceEnum';
import { getServiceBaseURL } from '../../MainModule/common/getServiceBaseURL';

export async function fetchPassportMassCancelReasons(): Promise<IPassportMassCancelReason[]> {
  return apiGet(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE, false)}/catalogs/passport-mass-cancel-reason`);
}
